import ToggleButton from "../common/ToggleButton.jsx";

const SubTasksTaskEditor = ({ subTasks = [], subTaskStatusHandler }) => {
  if (!subTasks.length) return null;

  return (
    <div className="subtasks-table-wrapper">
      <h3>Subtaken</h3>

      <table className="subtasks-table">
        <thead>
          <tr>
            <th>Status</th>
            <th>Titel</th>
            <th>Geschatte minuten</th>
            <th>Vervolgactie nodig</th>
          </tr>
        </thead>

        <tbody>
          {subTasks.map((subTask) => (
            <tr key={subTask.ID}>
              <td>
                <select
                  data-docid={subTask.docid}
                  value={subTask.Status}
                  onChange={subTaskStatusHandler}
                >
                  <option value="toDo">Te doen</option>
                  <option value="inProgress">Bezig</option>
                  <option value="done">Klaar</option>
                </select>
              </td>

              <td>{subTask.Title}</td>

              <td>
                {subTask?.EstimateMinutes ?? "—"}
              </td>

              <td>
                <ToggleButton
                  docid={subTask.docid}
                  id={'NeedsFollowUp'}
                  value={subTask?.NeedsFollowUp}
                  collection="Tasks"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SubTasksTaskEditor;
